import {PreloadAllModules, RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {FullLayoutComponent} from "./layouts/full-layout.component";
import {SimpleLayoutComponent} from "./layouts/simple-layout.component";
import {AuthGuard} from "./auth/auth-guard.service";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'products',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    component: SimpleLayoutComponent,
    data: {
      title: 'Auth'
    },
    children: [
      {
        path: '',
        loadChildren: './auth/auth.module#AuthModule',
      },
    ]
  },
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'BREADCRUMB.HOME'
    },
    children: [
      {
        path: 'analytics',
        loadChildren: './analytics/analytics.module#AnalyticsModule',
        data: {title: 'BREADCRUMB.ANALYTICS'}
      },
      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule',
        data: {title: 'BREADCRUMB.USERS'}
      },
      {
        path: 'products',
        loadChildren: './products/products.module#ProductsModule',
        data: {title: 'BREADCRUMB.PRODUCTS'}
      },
      {
        path: 'activity-calendar',
        loadChildren: './activity-calendar/activity-calendar.module#ActivityCalendarModule',
        data: {title: 'BREADCRUMB.ACTIVITY-CALENDAR'}
      },
      {
        path: 'notifications',
        loadChildren: './notifications/notifications.module#NotificationsModule',
        data: {title: 'BREADCRUMB.NOTIFICATIONS'}
      },
      {
        path: 'settings',
        loadChildren: './settings/settings.module#SettingsModule',
        data: {title: 'BREADCRUMB.SETTINGS'}
      },
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/roche/roche/src/app/app.routing.ts